import React from "react";
import "./TalentSection.css";

const TalentSection = () => {
  return (
    <section className="talent-section">
      <div className="overlay">
        <span className="tag">WHAT WE DO</span>
        <h1 className="title">
          Unlock Top Talent: Your Path to Premier Hiring Solutions, Based in
          Noida, India
        </h1>
      </div>
    </section>
  );
};

export default TalentSection;
